import {ZeroBet} from "@nolimitcity/slot-game/bin/timelinegameround/game/gameround/presentations/ZeroBet";
import {TimelineLite} from "gsap";
import {HorribleHeroesParsedGameData} from "../../server/data/HorribleHeroesParsedGameData";
import {HorribleHeroesGameMode} from "../../HorribleHeroesGameMode";
import {HorribleHeroes} from "../../HorribleHeroes";
import {HorribleHeroesGameConfig} from "../../HorribleHeroesGameConfig";

export class HorribleHeroesZeroBet extends ZeroBet {
    public getAnimation(data: HorribleHeroesParsedGameData): TimelineLite {
        const tl: TimelineLite = new TimelineLite(),
            fsLeft: number = ((data.nextMode === HorribleHeroesGameMode.FREESPIN_MID || HorribleHeroesGameMode.FREESPIN_LOW) ? data.freespinsLeft - 1 : -1);
        tl.add(() => {
            if (data.nextMode === HorribleHeroesGameMode.FREESPIN_PICK) {
                //related  issues #86 and #151
                //fix of #212 ,sending zero bet instead of pick & click bet so that it triggers API Bet

                //removed fix of 151 from freeSpinintroView as to send playerInteraction request needs to be send after all  finish calls from transition  (normal  to freespin pick)
                //and Freespin pick mode is entered
                const playerInteraction = {
                    selectedIndex: HorribleHeroesGameConfig.instance.SELECTED_INDEX
                };
                HorribleHeroes.api.betHandler.zeroBet(playerInteraction);
            } else {
                HorribleHeroes.api.betHandler.zeroBet();
            }

            HorribleHeroes.keypad.setZeroBetSpinCounter(fsLeft);
        });

        return tl;
    }
}